import { Component } from '@angular/core';

@Component({
    selector: 'sk-spinner',
    templateUrl: 'spinnerBase.component.html'
})

export class SpinnerBase { }



// WEBPACK FOOTER //
// ./src/app/components/common/spinners/spinnerBase.component.ts